import { connect } from 'react-redux';
import React from 'react';
// import {
//   MID_GET_MOBILE_FOOTER_DATA,
// } from '../../constants/middlewareActionsTypes';

const CombineFooterSwitch = React.lazy(() => import('../../components/Layouts/Switch/CombineFooterSwitch'));
// import {getFooterData} from '../../actions/footer.js';

// const mapStateToProps = (state) => {
//   const {
//     isMobile,
//     noHeaderFooter,
//     noReactHeaderFooter,
//     seoCate
//   } = state.commonState;
//   const { desktopFooterData, mobileFooterData } = state.footerState;
//   const { miniCartData } = state.cartState;
//   return {
//     miniCartData,
//     isMobile,
//     noHeaderFooter,
//     noReactHeaderFooter,
//     mobileFooterData,
//     desktopFooterData,
//     seoCate
//   };
// };

const mapDispatchToProps = (dispatch) => ({
  // getFooterData: (payload) => getFooterData(payload)(dispatch),
  // getMobileFooterData: (payload) => dispatch({ type: MID_GET_MOBILE_FOOTER_DATA, payload }),
});

export default connect(
  // mapStateToProps,
   mapDispatchToProps)(CombineFooterSwitch);
